// We cannot directly import SVG files, so we must instead define them in TS
/* eslint max-len: "off" */
export const pinnedStatusIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="var(--neutral-foreground-rest)" width="12" height="12" viewBox="0 0 2048 2048">
        <path
            d="M2014 853q0 58-32 106t-86 70l-535 223q-13 5-23 15t-14 25l-175 582q-6 20-22 33t-39 13q-26 0-45-19l-403-403-550 550H0v-91l550-549-403-403q-19-19-19-46 0-19 11-35t29-23l593-237q23-9 34-33l222-489q23-52 71-82t105-31q38 0 73 15t62 41l630 631q27 27 41 63t15 74zm-821-696q-20 0-35 10t-24 28L912 684q-15 34-42 59t-62 40L306 983l751 752 144-479q12-41 41-73t69-49l536-224q18-8 28-23t11-36q0-27-18-45l-631-630q-19-19-44-19z"
        />
    </svg>
`;
/* eslint max-len: "off" */
export const errorCircleIcon = `
    <svg width="24" height="24" viewBox="0 -7 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 2C17.523 2 22 6.478 22 12C22 17.522 17.523 22 12 22C6.477 22 2 17.522 2 12C2 6.478 6.477 2 12 2ZM12 3.667C7.405 3.667 3.667 7.405 3.667 12C3.667 16.595 7.405 20.333 12 20.333C16.595 20.333 20.333 16.595 20.333 12C20.333 7.405 16.595 3.667 12 3.667ZM11.9987 14.5022C12.5502 14.5022 12.9973 14.9494 12.9973 15.5009C12.9973 16.0524 12.5502 16.4996 11.9987 16.4996C11.4471 16.4996 11 16.0524 11 15.5009C11 14.9494 11.4471 14.5022 11.9987 14.5022ZM11.9945 7C12.3742 6.9997 12.6882 7.2816 12.7381 7.64764L12.7451 7.7494L12.7487 12.251C12.749 12.6652 12.4135 13.0013 11.9993 13.0016C11.6196 13.0019 11.3055 12.72 11.2556 12.354L11.2487 12.2522L11.2451 7.7506C11.2447 7.33639 11.5802 7.00033 11.9945 7Z"
            fill="#212121"
        />
    </svg>
`;
export const actionMenuIcon = `
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 10a1.25 1.25 0 11-2.5 0A1.25 1.25 0 016 10z" />
        <path d="M11.25 10a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z" />
        <path d="M15.25 11.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z" />
    </svg>
`;
